export enum FilterType {
  HierarchicalMenu,
  Menu,
  NumericRefinementList,
  NumericSelector,
  PriceRanges,
  Range,
  RefinementList,
  StarRating,
  Toggle
}

export function isRangeFilter(filterType: FilterType): boolean {
  return filterType === FilterType.Range || filterType === FilterType.PriceRanges;
}

export interface FacetFilter {
  type: FilterType;
  attributeName: string;
}

export type FacetValue = string | string[] | number | boolean;

export interface FilterValues<T> {
  [attributeName: string]: T;
}
